import { FC } from 'react';
import BasicButton, {
    BasicButtonProps,
} from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { CancelIcon } from '@shared/Icons/CancelIcon';
import React from 'react';
import css from './CloseButton.module.css';

interface CloseButtonProps extends Omit<BasicButtonProps, 'children'> {
    iconWidth?: number;
    iconHeight?: number;
    className?: string;
}

const CloseButton: FC<CloseButtonProps> = ({
    iconWidth = 17,
    iconHeight = 19,
    className = css.closeButton,
    ...rest
}) => {
    return (
        <BasicButton {...rest} className={className}>
            <CancelIcon width={iconWidth} height={iconHeight} />
        </BasicButton>
    );
};

export default React.memo(CloseButton);
